// extracted by mini-css-extract-plugin
module.exports = {"replace":"cart-replace-item_replace__dA_Qa","icon":"cart-replace-item_icon__AAvPp"};